import React from 'react';
import ModLocationInput from "./ModLocationInput";
import NonModLocationInput from "./NonModLocationInput";
export default function LocationInput({ ministryOfDefence, ...props }) { if (ministryOfDefence) {
    return /*#__PURE__*/ React.createElement(ModLocationInput, props);
}
else {
    return /*#__PURE__*/ React.createElement(NonModLocationInput, props);
} }
